import { Recency, RefreshRate } from "./types";

export const REFRESH_OPTIONS = Object.freeze([
  {
    value: RefreshRate.FIVE_MINUTES,
    label: "5 minutes",
  },
  {
    value: RefreshRate.ONE_MINUTE,
    label: "1 minute",
  },
  {
    value: RefreshRate.THIRTY_SECONDS,
    label: "30 seconds",
  },
]);

export const RECENCY_OPTIONS = Object.freeze([
  {
    value: Recency.ONE_MONTH,
    label: "1 month",
  },
  {
    value: Recency.ONE_WEEK,
    label: "1 week",
  },
  {
    value: Recency.ONE_DAY,
    label: "24 hours",
  },
  {
    value: Recency.EIGHT_HOURS,
    label: "8 hours",
  },
  {
    value: Recency.UNSET,
    label: "All time",
  },
]);
